// import React from 'react';
// import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// class DebriefMenu extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       links: [
//         // { name: 'Players', url: '/players' },
//         // { name: 'Debrief', url: '/debrief/overview' },
//         { name: 'Plan Composition', url: '/debrief/composition' },
//         { name: 'Investment', url: '/debrief/investment' },
//         { name: 'Investment Pre & Post', url: '/debrief/invprepost' },
//         { name: 'Intervention', url: '/debrief/intervention' },
//         { name: 'Intervention Pre & Post', url: '/debrief/intprepost' },
//         // { name: 'Download', url: '/debrief/download' },
//       ],
//     };

//     // Bindings
//   }

//   // componentWillReceiveProps(newProps){
//   //     this.setState({ game_id: newProps.game_id })
//   // }

//   render() {
//     const { game } = this.props;
//     const links = this.state.links.map((l, li) => {
//       const active = this.props.location.pathname.includes(l.url)
//         ? 'btn-blue'
//         : 'btn-link';
//       return (
//         <Link
//           key={'dm-' + li}
//           to={`/games/${game.data._id}${l.url}`}
//           className={`btn ${active} btn-sm ml-3 ${active}`}>
//           {l.name}
//         </Link>
//       );
//     });

//     return (
//       <div>
//         <div className='d-inline-block'>{links}</div>
//         <button
//           className='btn btn-sm btn-outline-primary ml-3'
//           onClick={(e) => window.location.reload()}>
//           <FontAwesomeIcon icon='redo-alt' />
//         </button>
//       </div>
//     );
//   }
// }

// function mapStateToProps(state) {
//   const { game } = state;
//   return {
//     game,
//   };
// }

// const connectedPage = connect(mapStateToProps)(DebriefMenu);
// export { connectedPage as DebriefMenu };

import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const DebriefMenu = () => {
  const game = useSelector((state) => state.game);
  const { t } = useTranslation();

  const links = [
    { name: 'Plan Composition', url: '/debrief/composition' },
    { name: 'Investment', url: '/debrief/investment' },
    { name: 'Investment Pre & Post', url: '/debrief/invprepost' },
    { name: 'Intervention', url: '/debrief/intervention' },
    { name: 'Intervention Pre & Post', url: '/debrief/intprepost' },
  ];

  const renderLinks = links.map((l, li) => (
    <NavLink
      key={'dm-' + li}
      to={`/games/${game.data._id}${l.url}`}
      className={({ isActive }) =>
        isActive ? 'btn btn-primary btn-sm ms-3' : 'btn btn-link btn-sm ms-3'
      }>
      {l.name}
    </NavLink>
  ));

  return (
    <div>
      <div className='d-inline-block'>{renderLinks}</div>
      <button
        className='btn btn-sm btn-outline-primary ms-3'
        onClick={() => window.location.reload()}>
        <FontAwesomeIcon icon='redo-alt' />
      </button>
    </div>
  );
};

export { DebriefMenu };
